import React, { Component, Fragment } from "react";

import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import utils from "../../../../../utils/utilsProducaoSTI";
import Card from "../../../../UI/Card";

export default class AnualV3 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Módulo de Metas",
            dados: {},
            mesSelecionado: "janeiro",
            isAcumulado: false,
            radioChecked: "mes",
            previstoRealizado: this.props.metas ? "Previsto" : "Realizado",
            valorRowSpan: this.props.metas !== undefined && this.props.realizados !== undefined ? 2 : 1
        }
    }

    async componentDidMount() {
        this.atualizaDados();
    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevProps.metas !== this.props.metas) {
            this.atualizaDados();
        }
    }

    atualizaDados = () => {
        let { metas, realizados, isAcumulado } = this.props;
        // verifica meta
        if(!metas) {
            let dados = []
            Object.keys(realizados).map((unidade) => {
                dados.push(realizados[unidade]);
            });
            metas = dados;
            realizados = undefined
        }
        this.setState({ metas, realizados, isAcumulado });
    }

    // ************* Metas **************** //

    groupBy = (objectArray, property) => {
        return objectArray.reduce(function (acc, obj) {
            var key = obj[property];
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});
    }

    formataNumero = (meta, modal, coluna, mes) => {

        try {
            let valor = meta.modalidades[modal][coluna][mes];
            return valor
        }
        catch (erro) {
            console.warn(">>>>>>>>>>>>>", erro, { meta, modal, coluna, mes })
            return 0;
        }

    }

    formataColuna = (coluna) => {
        switch(coluna) {
            case "calibracoes":
                coluna = "Calibrações"
                break;
            case "ensaios":
                coluna = "Ensaios"
                break;
            case "horasTecnicas":
                coluna = "Horas Técnicas"
                break;
            case "numeroAtendimento":
                coluna = "Número de Atendimento"
                break;
            case "relatoriosELaudos":
                coluna = "Relatórios/Laudos"
                break;
            case "receita":
                coluna = "Receita"
                break;
            case "despesa":
                coluna = "Despesa"
                break;
        }
        return coluna;
    }

    previsto = (valor, val, coluna) => {
        if(['receita', 'despesa'].includes(coluna)) return
        let { previstoRealizado, valorRowSpan } = this.state;
        let totalColuna = this.state.isAcumulado ? Math.max(...valor.modalidades[val][coluna]) : valor.modalidades[val][coluna].reduce((acc, atual) => acc + atual, 0);
        return (
            <tr>
                <th rowSpan={valorRowSpan}>{this.formataColuna(coluna)}</th>
                <td>{previstoRealizado}</td>
                {valor.modalidades[val][coluna].map((resultado) => <td rowSpan={1} >{coluna === "receita" ? utils.formataNumeroMoeda(resultado) : utils.formataNumero(resultado)}</td>)}
                <td>{coluna === "receita" ? utils.formataNumeroMoeda(totalColuna) : utils.formataNumero(totalColuna)}</td>
            </tr> 
        )
    }

    realizado = (realizados, val, coluna, sigla) => {
        if(['receita', 'despesa'].includes(coluna)) return
        let indice = realizados.findIndex((nome) => nome.unidade === sigla);
        let realizado;

        try {
            realizado = realizados[indice].modalidades[val][coluna];
        } catch (error) {
            realizado = undefined;
        }

        let totalColunaRealizados = 0;
        let valoresMensais = new Array(12).fill((<td>0</td>));
        if(realizado) {
            totalColunaRealizados = realizado.reduce((acc, atual) => acc + atual, 0);
            totalColunaRealizados = this.verificaValorTotal(realizado);
            valoresMensais = realizado.map((resultado) => <td rowSpan={1}>{utils.formataNumero(resultado)}</td>)
        }
        
        return(
            <tr>
                <td style={{ backgroundColor: "#f2f2f2" }}>Realizado</td>
                {valoresMensais}
                <td>{utils.formataNumero(totalColunaRealizados)}</td>
            </tr> 
        )
    }

    isExibeIndicador = (unidade, categoria, coluna) => {
        let exibe = true;

        let consultTec = ["Consultoria em Tecnologia", "Consultoria em Processos Produtivos", "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos"]
        let consultTecColuna = ["ensaios", "calibracoes", "despesa", "relatoriosELaudos"]

        let servTec = ["Serviços Técnicos Especializados", "Serviços Operacionais"]
        let servTecColuna = ["ensaios", "calibracoes", "despesa", "relatoriosELaudos"]

        let pesquisa = ["Pesquisa, Desenvolvimento e Inovação de Produto", "Pesquisa, Desenvolvimento e Inovação"]
        let pesquisaColuna = ["ensaios", "calibracoes", "despesa", "relatoriosELaudos"]

        let metroEnsaiosColuna = ["calibracoes", "despesa", "horasTecnicas"]
        let metroCalibracoesColuna = ["ensaios", "despesa", "horasTecnicas"]
        let metroColuna = ["despesa", "horasTecnicas"]

        if(consultTec.includes(categoria) && consultTecColuna.includes(coluna)) {
            exibe = false;
        }
        if(servTec.includes(categoria) && servTecColuna.includes(coluna)) {
            exibe = false;
        }
        if(pesquisa.includes(categoria) && pesquisaColuna.includes(coluna)) {
            exibe = false;
        }
        if(categoria === "Ensaios" && metroEnsaiosColuna.includes(coluna)) {
            exibe = false;
        }
        if(categoria === "Calibração" && metroCalibracoesColuna.includes(coluna)) {
            exibe = false;
        }
        if(categoria === "Metrologia" && metroColuna.includes(coluna)) {
            exibe = false;
        }
        return exibe;
    }

    verificaValorTotal = (total) => {
        if(this.state.isAcumulado) total = Math.max(...total);
        else total = total.reduce((acc, atual) => acc + atual, 0);
        return total;
    }

    render() {
        let { realizados, metas } = this.state;
        let meses = ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
        return (
            <Fragment>
                <Card className="mt-5">

                    <Tabs defaultActiveKey={"DR"} activeKey={this.props.unidade} style={{visibility: "collapse"}}>

                        {metas && Object.keys(metas).map((nomeUnidade, i) => {

                            let valor = metas[nomeUnidade]
                            let sigla = valor.unidade;
                            let indice = metas.findIndex((nome) => nome.unidade === valor.unidade);

                            return (
                                <Tab eventKey={sigla} title={sigla}>

                                    <Tabs defaultActiveKey={"Serviços Operacionais"}>
                                        <hr />
                                        {Object.keys(valor.modalidades).map((val, j) => {
                                            return (

                                                <Tab eventKey={val} title={val} >

                                                    <Fragment>
                                                        <table border="1" className="table table-bordered table-hover table-sm table-striped">
                                                            <thead>
                                                                <tr>
                                                                    <th colSpan="15" className="text-center">{valor.unidade}</th>
                                                                </tr>
                                                                <tr>
                                                                    <th rowSpan="15" colSpan="2">Indicador</th>
                                                                </tr>
                                                                <tr>
                                                                    <th colSpan="14" className="text-center">{val}</th>
                                                                </tr>
                                                                <tr>
                                                                    {meses.map(mes => <th><span style={{ textTransform: "uppercase" }}>{mes}</span></th>)}
                                                                    <th>TOTAL</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {Object.keys(valor.modalidades[val]).map((coluna, y) => {
                                                                    return(
                                                                        this.isExibeIndicador(valor.unidade, val, coluna) ?
                                                                            <Fragment>
                                                                                {metas ? this.previsto(valor, val, coluna) : null}
                                                                                {realizados ? this.realizado(realizados, val, coluna, sigla) : null}
                                                                            </Fragment>  
                                                                        :
                                                                        null

                                                                    )
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </Fragment>

                                                </Tab>

                                            )
                                        })}
                                    </Tabs>

                                </Tab>
                            )
                        })}

                    </Tabs>
                * Receita (Realizado) não disponibilizado no SIGEM
                </Card>

            </Fragment>
        )
    }
}